// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1v_Kl","footer":"styles_footer__3AriH","passCodeTooltip":"styles_passCodeTooltip__2Usju"};